const API_URL = process.env.REACT_APP_API_URL;

let apiUrls =  {
    elements: `${API_URL}/art-elements`,
    saveDiscountTable: `${API_URL}/art-element/save-discount-table`
};

export default apiUrls;
